import { render, staticRenderFns } from "./EquipmentTransferItemsTable.vue?vue&type=template&id=6346cc06"
import script from "./EquipmentTransferItemsTable.vue?vue&type=script&lang=js"
export * from "./EquipmentTransferItemsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports